import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrequentServicesPreviewComponent } from '@client-monorepo/common/app-services';
import { NgxSkeletonLoadingComponent } from '@digipay/ngx-skeleton-loading';
import { FrequentServiceInterface } from '@client-monorepo/common/service-data';

@Component({
  selector: 'hub-applet-search-result',
  standalone: true,
  imports: [CommonModule, FrequentServicesPreviewComponent, NgxSkeletonLoadingComponent],
  templateUrl: './search-result.component.html',
  styleUrl: './search-result.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultComponent {
  isLoading = input(false);
  service = input<FrequentServiceInterface>({} as FrequentServiceInterface);
  clicked = output<FrequentServiceInterface>();

  handleClick(): void {
    if (!this.isLoading() && this.service()) {
      this.clicked.emit(this.service());
    }
  }
}
